import { memo } from 'react';
import { Task } from '../../types/Task.interface';
import SortedSelect, { SortedSelectProps } from './SortedSelect';

export type TaskSelectProps = {
    selectedTask: number;
    taskOptions: Task[];
} & Omit<SortedSelectProps<Task>, 'selectedValue' | 'options'>;

function TaskSelect({ selectedTask, taskOptions, onChange, label = 'Task', ...props }: TaskSelectProps) {
    return (
        <SortedSelect selectedValue={selectedTask} options={taskOptions} onChange={onChange} label={label} {...props} />
    );
}

export default memo(TaskSelect);
